import { feedStore } from 'redux/actions/feed-store-actions';
import { useEffect } from 'react';
import { useUser } from 'hooks/redux/useUser';
import { useDispatch } from 'react-redux';
import { isFulfilled } from 'redux/statuses';
import { useAgencies } from 'hooks/redux/useAgencies';
import { useGroups } from 'hooks/redux/useGroups';
import { useMarketplaces } from 'hooks/redux/useMarketplaces';
import { useWarehouses } from 'hooks/redux/useWarehouses';

export function useFeedStore() {
  const dispatch = useDispatch();
  const { userStatus } = useUser();
  const { agenciesStatus } = useAgencies();
  const { groupsStatus } = useGroups();
  const { marketplacesStatus } = useMarketplaces();
  const { warehousesStatus } = useWarehouses();

  useEffect(() => {
    setTimeout(() => {
      dispatch(feedStore());
    }, 100);
  }, [dispatch]);

  return (
    !isFulfilled(userStatus) ||
    !isFulfilled(agenciesStatus) ||
    !isFulfilled(groupsStatus) ||
    !isFulfilled(marketplacesStatus) ||
    !isFulfilled(warehousesStatus)
  );
}
